import ApiBase from '@/api/api-base'
import {ACTIVE_BASE_REST} from '@/api/constants'

export default class MessageSentSms extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/message/sms/sent'
        super(store, path)
    }
}